(function () {
  var OPEN_CLASS = 'is-country-drawer-open';
  var FOCUSABLE = 'button:not([disabled]), [href], select:not([disabled]), input:not([disabled]):not([type="hidden"]), textarea:not([disabled]), [tabindex]:not([tabindex^="-"])';

  var drawer = document.getElementById('CountryDrawer');
  var backdrop = document.getElementById('CountryDrawerBackdrop');
  if (!drawer) return;

  var lastFocused = null;
  var isOpen = false;

  function focusableElements() {
    return Array.prototype.filter.call(drawer.querySelectorAll(FOCUSABLE), function (el) {
      return el.offsetParent !== null;
    });
  }

  function onKeydown(event) {
    if (event.key === 'Escape' || event.keyCode === 27) {
      event.preventDefault();
      close();
      return;
    }

    if (event.key !== 'Tab' && event.keyCode !== 9) return;

    var elements = focusableElements();
    if (!elements.length) return;

    var first = elements[0];
    var last = elements[elements.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function closeMobileNav() {
    document.body.classList.remove('menu_open');
    document.documentElement.classList.remove('menu_open');
    document.querySelectorAll('.js-drawer-open-nav[aria-expanded="true"]').forEach(function (button) {
      button.setAttribute('aria-expanded', 'false');
    });
  }

  function open(trigger) {
    if (isOpen) return;

    lastFocused = trigger || document.activeElement;
    closeMobileNav();

    drawer.classList.add('is-open');
    // Force a reflow so the transform transition runs from its off-canvas state.
    drawer.offsetHeight;
    drawer.classList.add('is-visible');

    document.documentElement.classList.add(OPEN_CLASS, 'lock-scroll');
    document.body.classList.add('lock-scroll');
    if (backdrop) backdrop.setAttribute('aria-hidden', 'false');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');

    isOpen = true;
    document.addEventListener('keydown', onKeydown);

    var elements = focusableElements();
    (elements[0] || drawer).focus();
  }

  function close() {
    if (!isOpen) return;

    drawer.classList.remove('is-visible');
    document.documentElement.classList.remove(OPEN_CLASS, 'lock-scroll');
    document.body.classList.remove('lock-scroll');
    if (backdrop) backdrop.setAttribute('aria-hidden', 'true');

    document.querySelectorAll('.js-country-drawer-open').forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    });

    isOpen = false;
    document.removeEventListener('keydown', onKeydown);

    window.setTimeout(function () {
      if (!isOpen) drawer.classList.remove('is-open');
    }, 250);

    // The mobile nav is closed when the drawer opens, so its trigger is no longer
    // focusable: fall back to the button that reopens the nav.
    var returnTo = lastFocused;
    if (returnTo && returnTo.offsetParent === null) {
      returnTo = document.querySelector('.js-drawer-open-nav');
    }

    if (returnTo && typeof returnTo.focus === 'function') {
      returnTo.focus();
    }
  }

  document.querySelectorAll('.js-country-drawer-open').forEach(function (trigger) {
    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      open(trigger);
    });
  });

  drawer.querySelectorAll('.js-country-drawer-close').forEach(function (button) {
    button.addEventListener('click', close);
  });

  if (backdrop) backdrop.addEventListener('click', close);

  /* Country -> language ---------------------------------------------------- */

  var languageSelect = drawer.querySelector('[data-language-select]');
  var languageField = drawer.querySelector('[data-language-field]');
  var localizationMap = { markets: {}, countries: {} };

  try {
    var mapScript = drawer.querySelector('[data-country-language-map]');
    if (mapScript) localizationMap = JSON.parse(mapScript.textContent);
  } catch (error) {
    localizationMap = { markets: {}, countries: {} };
  }

  // Shopify doesn't expose a country's own language, so these are the ones a shopper
  // from there most likely reads; the first one the market offers is preselected.
  var COUNTRY_LANGUAGES = {
    AT: ['de'], DE: ['de'], LI: ['de'], CH: ['de', 'fr', 'it'], LU: ['fr', 'de'],
    FR: ['fr'], MC: ['fr'], BE: ['nl', 'fr'], NL: ['nl'],
    IT: ['it'], SM: ['it'], VA: ['it'], ES: ['es'], AD: ['es', 'fr'], PT: ['pt-pt', 'pt'],
    DK: ['da'], SE: ['sv'], NO: ['nb', 'no'], FI: ['fi', 'sv'], IS: ['is'],
    PL: ['pl'], CZ: ['cs'], SK: ['sk'], HU: ['hu'], RO: ['ro'], BG: ['bg'], HR: ['hr'], SI: ['sl'],
    GR: ['el'], CY: ['el'], EE: ['et'], LV: ['lv'], LT: ['lt'], IE: ['en'], MT: ['en'], GB: ['en']
  };

  function languagesForCountry(code) {
    var handle = localizationMap.countries[code];
    return (handle && localizationMap.markets[handle]) || [];
  }

  function countryLanguage(code, languages) {
    var match = null;
    (COUNTRY_LANGUAGES[code] || []).some(function (wanted) {
      languages.some(function (language) {
        var available = language.code.toLowerCase();
        if (available === wanted || available.split('-')[0] === wanted) match = language.code;
        return match;
      });
      return match;
    });
    return match;
  }

  // Languages belong to a market, so the list has to follow the chosen country.
  function renderLanguages(code, preferCountryLanguage) {
    if (!languageSelect) return;

    var languages = languagesForCountry(code);
    if (!languages.length) return;

    var previous = languageSelect.value;
    languageSelect.textContent = '';

    languages.forEach(function (language) {
      var option = document.createElement('option');
      option.value = language.code;
      option.lang = language.code;
      option.textContent = language.name;
      languageSelect.appendChild(option);
    });

    var stillAvailable = languages.some(function (language) {
      return language.code === previous;
    });

    var preferred = null;
    if (preferCountryLanguage && COUNTRY_LANGUAGES[code]) {
      preferred = countryLanguage(code, languages) || languages[0].code;
    }

    // Shopify falls back to the market's default language, so mirror that here.
    languageSelect.value = preferred || (stillAvailable ? previous : languages[0].code);

    if (languageField) languageField.hidden = languages.length < 2;
  }

  var countrySelect = drawer.querySelector('[data-country-select]');

  // Only a country the shopper just picked switches the language; on load and on
  // back/forward the drawer keeps the language they are browsing in.
  function syncCountry(event) {
    renderLanguages(countrySelect.value, !!event && event.type === 'change');

    var flag = drawer.querySelector('.country-drawer__flag');
    if (!flag) return;

    flag.style.visibility = 'visible';
    flag.src = flag.getAttribute('src')
      .split('?')[0]
      .replace(/flag-[a-z]{2}\.png$/, 'flag-' + countrySelect.value.toLowerCase() + '.png');
  }

  if (countrySelect) {
    syncCountry();
    countrySelect.addEventListener('change', syncCountry);

    // Back/forward navigation can restore the select to a stale choice without firing change.
    window.addEventListener('pageshow', syncCountry);
  }
})();
